import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Card } from 'reactstrap';

import './Panel.scss';

const ns = 'panel';

const Panel = props => {
  const { children, className, ...tprops } = props;
  const classProps = classNames(ns, className);

  return (
    <Card {...tprops} className={classProps}>
      {children}
    </Card>
  );
};

Panel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

Panel.defaultProps = {
  className: ''
};

export default Panel;



// WEBPACK FOOTER //
// ./src/components/atoms/Panel/Panel.js